<template>
	<div class="subtitle-container">
		<p class="subtitle">
			{{ value }}
		</p>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
		name: 'Subtitle',
		props: {
			value: {
				type: String,
				required: true,
			},
		},
		methods: {
			...mapActions('system', ['ToggleSubtitle']),
		},
		mounted() {
			this.ToggleSubtitle(true)
		},
		beforeDestroy() {
			this.ToggleSubtitle(false)
		},
	}
</script>

<style lang="scss">
	.subtitle-container {
		height: var(--subtitleHeight);
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid var(--elementsBorderColor);

		.subtitle {
			color: var(--titleColor);
			font-size: 1.75rem;
			font-weight: 700;
			letter-spacing: 0.031rem;
			line-height: 1;
			text-align: center;
			text-transform: uppercase;
			margin: 0;
		}
	}
</style>
